import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ContactCompanyRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("contactcompany");
